<div
  stack-layout
  [fullHeight]="true"
  paddingHorizontal="md"
  paddingTop="md"
  gap="md"
  paddingBottom="md"
>
  <div stack-layout gap="xs">
    <div
      row-layout
      paddingHorizontal="sm"
      justifyContent="space-between"
      alignItems="center"
    >
      <Text role="headline-large" color="on-background" display="block"
        >{{ headline() }}</Text
      >
      <div>
        <ng-content select="headline-actions"></ng-content>
      </div>
    </div>
    <Divider orientation="horizontal" border="primary"></Divider>
  </div>

  <div box-layout [grow]="1">
    <ng-content></ng-content>
  </div>
</div>
